import React, { useState, useEffect } from "react";
import InvoiceLayout from "../components/layout/InvoiceLayout.jsx";
import {
  Box,
  Typography,
  Container,
  TextField,
  Grid,
  Button,
  IconButton,
  Avatar,
  Snackbar,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdDelete, MdAdd, MdSend } from "react-icons/md";
import { FaRupeeSign } from "react-icons/fa";
import configuration from "../config";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  section: {
    marginBottom: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 5,
  },
  text: {
    fontSize: 9,
    lineHeight: 1.4,
    color: "#333",
  },
  table: {
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    paddingVertical: 8,
  },
  tableHeader: {
    backgroundColor: "#f8f9fa",
    borderBottomWidth: 1,
    borderBottomColor: "#dee2e6",
  },
  tableCol: {
    flex: 1,
    justifyContent: "center",
  },
  tableCell: {
    fontSize: 9,
    padding: 4,
  },
  headerCell: {
    fontSize: 9,
    fontWeight: "bold",
    padding: 4,
  },
  orderInfo: {
    marginBottom: 15,
    borderBottom: 1,
    borderBottomColor: "#eee",
    paddingBottom: 10,
  },
  addressSection: {
    marginTop: 10,
    marginBottom: 15,
  },
  addressTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 5,
  },
  totalTable: {
    width: "40%",
    marginLeft: "auto",
    marginTop: 5,
    marginBottom: 5,
  },
  totalRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    paddingVertical: 8,
  },
  totalLabel: {
    flex: 1,
    fontSize: 9,
    fontWeight: "bold",
  },
  totalValue: {
    flex: 1,
    fontSize: 9,
    textAlign: "right",
  },
  totalSection: {
    marginTop: 15,
    borderTop: 1,
    borderTopColor: "#eee",
    paddingTop: 10,
  },
  footer: {
    marginTop: 30,
    fontSize: 8,
    color: "#666",
  },
  gstInfo: {
    marginTop: 15,
    fontSize: 8,
    color: "#666",
  },
  authorizedSignature: {
    marginTop: 20,
    width: "50%",
    borderTop: "1px solid #333",
    paddingTop: 10,
    fontSize: 9,
  },
  paymentInfo: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 9,
  },
  signatureBox: {
    marginTop: 2,
    padding: 10,
    borderWidth: 1,
    borderColor: "#333",
  },
  termsConditions: {
    marginTop: 2,
    fontSize: 8,
    color: "#666",
  },
  taxInfo: {
    marginTop: 2,
    fontSize: 8,
    color: "#666",
  },
});

const InvoicePDF = ({
  businessInfo,
  billTo,
  items,
  subtotal,

  discount,
  total,
  currentDate,
  dueDate,
  paymentInfo,
  globalDiscountAmount,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={{ alignItems: "center", marginBottom: 20 }}>
        <Text style={{ fontSize: 14, fontWeight: "bold" }}>Tax Invoice</Text>
      </View>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View style={{ alignItems: "center" }}>
          <Text style={{ fontSize: 14, fontWeight: "bold" }}>
            {businessInfo.name}
          </Text>
        </View>
        <View>
          <Text>Date: {currentDate.toLocaleDateString()}</Text>
          <Text>
            Due Date: {dueDate ? dueDate.toLocaleDateString() : "N/A"}
          </Text>
        </View>
      </View>
      <View style={styles.section}>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <View>
            <Text style={styles.subtitle}>Bill To:</Text>
            <Text style={styles.text}>{billTo.name}</Text>
            <Text style={styles.text}>{billTo.address}</Text>
            <Text style={styles.text}>Email: {billTo.email}</Text>
            <Text style={styles.text}>Phone: {billTo.phoneNo}</Text>
            <Text style={styles.text}>Gst No: {billTo.gstNo}</Text>
          </View>
          <View>
            <Text style={styles.subtitle}>Bill From:</Text>
            <Text style={styles.text}>{businessInfo.name}</Text>
            <Text style={styles.text}>{businessInfo.address}</Text>
            <Text style={styles.text}>Email: {businessInfo.email}</Text>
            <Text style={styles.text}>Phone: {businessInfo.phoneNo}</Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <View style={[styles.tableCol, { flex: 0.1 }]}>
              <Text style={styles.headerCell}>#</Text>
            </View>
            <View style={[styles.tableCol, { flex: 2 }]}>
              <Text style={styles.headerCell}>Description</Text>
            </View>
            <View style={[styles.tableCol, { flex: 1 }]}>
              <Text style={styles.headerCell}>Quantity</Text>
            </View>
            <View style={[styles.tableCol, { flex: 1 }]}>
              <Text style={styles.headerCell}>Rate</Text>
            </View>
            <View style={[styles.tableCol, { flex: 1 }]}>
              <Text style={styles.headerCell}>Amount</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={[styles.tableCol, { flex: 0.1 }]}>
                <Text style={styles.tableCell}>{index + 1}</Text>
              </View>
              <View style={[styles.tableCol, { flex: 2 }]}>
                <Text style={styles.tableCell}>{item.description}</Text>
              </View>
              <View style={[styles.tableCol, { flex: 1 }]}>
                <Text style={styles.tableCell}>
                  {item.qty}
                  {item.unit}
                </Text>
              </View>
              <View style={[styles.tableCol, { flex: 1 }]}>
                <Text style={styles.tableCell}>₹{item.rate.toFixed(2)}</Text>
              </View>
              <View style={[styles.tableCol, { flex: 1 }]}>
                <Text style={styles.tableCell}>
                  ₹{(item.qty * item.rate).toFixed(2)}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.section}>
        <View style={styles.totalTable}>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Subtotal:</Text>
            <Text style={styles.totalValue}>₹{subtotal.toFixed(2)}</Text>
          </View>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Discount:</Text>
            <Text style={styles.totalValue}>
              ₹{globalDiscountAmount.toFixed(2)}
            </Text>
          </View>

          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Total:</Text>
            <Text style={styles.totalValue}>₹{total.toFixed(2)}</Text>
          </View>
        </View>
      </View>

      <View style={[styles.section, styles.signatureBox]}>
        <Text style={styles.authorizedSignature}>Authorized Signature</Text>
      </View>

      <View style={[styles.section, styles.termsConditions]}>
        Terms & Conditions:
        <Text style={styles.taxInfo}>
          Thank you for choosing to do business with us
        </Text>
      </View>

      <View style={[styles.section, styles.paymentInfo]}>
        <Text>Payment Transaction ID:</Text>
        <Text>Date & ID: </Text>
        <Text>Invoice Value: ₹{total.toFixed(2)}</Text>
        <Text>Mode of Payment: </Text>
      </View>
    </Page>
  </Document>
);

const InvoiceManagement = () => {
  const selectedCompanyInfo = useSelector(
    (state) => state.kyc.selectedCompanyInfo
  );
  const selectedAddress = useSelector((state) => state.kyc.selectedAddress);
  const selectedContactInfo = useSelector(
    (state) => state.kyc.selectedContactInfo
  );

  const selectedTaxInfo = useSelector((state) => state.kyc.selectedTaxInfo);
  const businessInfo = {
    name: selectedCompanyInfo?.legalName,
    gstNo: selectedTaxInfo?.vatGstNumber,
    address: selectedAddress?.operatingOffice?.street,
    email: selectedContactInfo?.primaryContact?.email,
    phoneNo: selectedContactInfo?.primaryContact?.phone,
  };

  const [currentDate, setCurrentDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(new Date());
  const [billTo, setBillTo] = useState({
    name: "",
    email: "",
    address: "",
    phoneNo: "",
  });
  const [billBy, setBillBy] = useState({
    name: businessInfo.name || "",
    gstNo: businessInfo.gstNo || "",
    email: businessInfo.email || "",
    address: businessInfo.address || "",
  });
  const [items, setItems] = useState([
    {
      id: "",
      description: "",
      qty: "",
      unit: "",
      rate: "",
      gst: "",
      Discount: "",
      total: "",
    },
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [discount] = useState(0);

  const [globalDiscountPercent, setGlobalDiscountPercent] = useState(0);
  const [globalDiscountAmount, setGlobalDiscountAmount] = useState(0);

  const { API_BASE_URL } = configuration;
  const [comment, setComment] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gstError, setGstError] = useState("");


  const validateGST = (gst) => {
  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return regex.test(gst);
};
const handleGstBillToChange = (e) => {
  const { name, value } = e.target;

  setBillTo((prev) => ({
    ...prev,
    [name]: value.toUpperCase(), 
  }));

  if (name === "gstNo") {
    if (value === "" || validateGST(value)) {
      setGstError("");
    } else {
      setGstError("Invalid GST number format");
    }
  }
};

  const extractUniqueProducts = (data) => {
    const uniqueProducts = new Set();
    data.forEach((item) => {
      if (item.description) {
        uniqueProducts.add(item.description);
      } else if (item.items) {
        item.items.forEach((subItem) => {
          uniqueProducts.add(subItem.description);
        });
      }
    });

    return Array.from(uniqueProducts).map((description) => ({
      description,
      label: description,
    }));
  };

  const fetchProducts = async (selectedCompanyId, API_BASE_URL) => {
    if (!selectedCompanyId) {
      return [];
    }

    try {
      const [invoiceResponse, productResponse] = await Promise.all([
        axios.get(
          `${API_BASE_URL}/api/v1/getInvoiceBykyc/${selectedCompanyId}`
        ),
        axios.get(`${API_BASE_URL}/api/v1/inventory/kyc/${selectedCompanyId}`),
      ]);

      const invoiceProducts =
        invoiceResponse.data && Array.isArray(invoiceResponse.data)
          ? extractUniqueProducts(invoiceResponse.data)
          : [];

      const directProducts =
        productResponse.data && Array.isArray(productResponse.data)
          ? extractUniqueProducts(productResponse.data)
          : [];

      return [...new Set([...invoiceProducts, ...directProducts])];
    } catch (err) {
      console.error("Error fetching products:", err);
      throw err;
    }
  };

  const selectedCompanyId = useSelector((state) => state.kyc.selectedCompanyId);
  const units = ["kg", "g", "L", "mL", "pcs", "set", "m", "hr", "box", "dozen"];

  const generateUniqueInvoiceId = async () => {
    let isUnique = false;
    let newInvoiceId = "";

    while (!isUnique) {
      const prefix = "INV";
      const uuid = uuidv4().replace(/-/g, "").substr(0, 8).toUpperCase();
      newInvoiceId = `${prefix}-${uuid}`;

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/v1/checkInvoiceId/${newInvoiceId}`
        );
        const data = await response.json();
        isUnique = !data.exists;
      } catch (error) {
        console.error("Error checking invoice ID:", error);

        isUnique = true;
      }
    }

    return newInvoiceId;
  };

  useEffect(() => {
    const initializeInvoiceId = async () => {
      const uniqueId = await generateUniqueInvoiceId();
      setInvoiceId(uniqueId);
    };

    initializeInvoiceId();
  }, []);
  const calculateItemTotal = (item) => {
    const quantity = parseFloat(item.qty) || 0;
    const rate = parseFloat(item.rate) || 0;
    const gst = parseFloat(item.gst) || 0;
    const itemDiscount = parseFloat(item.Discount) || 0;

    const subtotal = quantity * rate;
    const gstAmount = (subtotal * gst) / 100;
    const totalWithGST = subtotal + gstAmount;
    const discountAmount = (totalWithGST * itemDiscount) / 100;
    const finalTotal = totalWithGST - discountAmount;

    return finalTotal;
  };

  const updateSubtotalAndTotal = (newItems) => {
    const newSubtotal = newItems.reduce(
      (sum, item) => sum + calculateItemTotal(item),
      0
    );
    setSubtotal(newSubtotal);

    const discountAmount = (newSubtotal * globalDiscountPercent) / 100;
    setGlobalDiscountAmount(discountAmount);

    const finalTotal = Math.max(newSubtotal - discountAmount, 0);
    setTotal(finalTotal);
  };

  useEffect(() => {
    updateSubtotalAndTotal(items);
  }, [items, globalDiscountPercent]);

  const handleItemChange = (id, field, value) => {
    setItems((prevItems) => {
      const newItems = prevItems.map((item) => {
        if (item.id === id) {
          const updatedItem = {
            ...item,
            [field]:
              field === "qty" ||
              field === "rate" ||
              field === "gst" ||
              field === "discount"
                ? Number(value)
                : value,
          };
          updatedItem.total = calculateItemTotal(updatedItem);
          return updatedItem;
        }
        return item;
      });

      updateSubtotalAndTotal(newItems);
      return newItems;
    });
  };

  const addItem = () => {
    const newId =
      items.length > 0 ? Math.max(...items.map((item) => item.id)) + 1 : 1;
    setItems((prevItems) => {
      const newItems = [
        ...prevItems,
        {
          id: newId,
          description: "",
          qty: "",
          unit: "",
          rate: "",
          gst: "",
          Discount: "",
          total: "",
        },
      ];
      updateSubtotalAndTotal(newItems);
      return newItems;
    });
  };

  const deleteItem = (id) => {
    setItems((prevItems) => {
      const newItems = prevItems.filter((item) => item.id !== id);
      updateSubtotalAndTotal(newItems);
      return newItems;
    });
  };

  const handleBillToChange = (e) => {
    const { name, value } = e.target;
    setBillTo((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        const fetchedProducts = await fetchProducts(
          selectedCompanyId,
          API_BASE_URL
        );
        setProducts(fetchedProducts);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [selectedCompanyId, API_BASE_URL]);

  const generateEInvoice = () => {
    const currentDate = new Date();
    const eInvoice = `
  E-INVOICE
  
  Invoice Number: INV-${invoiceId}
  Date: ${currentDate.toLocaleDateString()}
  Due Date: ${dueDate ? dueDate.toLocaleDateString() : "N/A"}
  
  Bill From:
  Name: ${businessInfo.name || "N/A"}
  GST No: ${businessInfo.gstNo || "N/A"} 
  Address: ${businessInfo.address || "N/A"}
  Email: ${businessInfo.email || "N/A"}
  Phone No: ${businessInfo.phoneNo || "N/A"}
  
  Bill To:
  Name: ${billTo.name || "N/A"}
  GST No: ${billTo.gstNo || "N/A"}
  Address: ${billTo.address || "N/A"}
  Email: ${billTo.email || "N/A"}
  Phone No: ${billTo.phoneNo || "N/A"}
  
  Items:
  ${items
    .map(
      (item) => `
    Description: ${item.description || "N/A"}
    Quantity: ${item.qty}${item.unit}
    Rate: ₹${parseFloat(item.rate).toFixed(2)}
    GST: ${item.gst}%
    Discount:₹ ${item.Discount}
    Amount: ₹${(item.qty * item.rate).toFixed(2)}`
    )
    .join("\n")}
  

  Discount: ${globalDiscountAmount.toFixed(2)}%
  
  Total: ₹${total.toFixed(2)}

  commant:${comment}
  
  Thank you for choosing to do business with us!
  `;

    const blob = new Blob([eInvoice], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `eInvoice-${Date.now()}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const sendInvoiceToCustomer = async () => {
    const uniqueInvoiceId = await generateUniqueInvoiceId();
    setInvoiceId(uniqueInvoiceId);

    const invoiceData = {
      invoiceId: uniqueInvoiceId,
      billTo: billTo,
      billBy: billBy,
      items: items,
      subtotal: subtotal,

      discount: discount,
      total: total,
      currentDate: currentDate,
      dueDate: dueDate,
      comment: comment,
      globalDiscountAmount: globalDiscountAmount,
    };

    const blob = await pdf(
      <InvoicePDF
        businessInfo={businessInfo}
        billTo={invoiceData.billTo}
        billBy={invoiceData.billBy}
        gstNo={billTo.gstNo}
        items={invoiceData.items}
        subtotal={invoiceData.subtotal}
        tax={invoiceData.tax}
        discount={invoiceData.discount}
        total={invoiceData.total}
        currentDate={invoiceData.currentDate}
        dueDate={invoiceData.dueDate}
        comment={invoiceData.comment}
        globalDiscountAmount={globalDiscountAmount}
      />
    ).toBlob();

    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = async () => {
      const base64data = reader.result.split(",")[1];

      const invoiceDataToSend = {
        ...invoiceData,
        ...billBy,
        customerEmail: invoiceData.billTo.email,
        invoicePdf: base64data,
        kycId: selectedCompanyId,
      };

      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/sendInvoice`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(invoiceDataToSend),
        });

        if (response.ok) {
          setSnackbarOpen(true);
          setSnackbarMessage("Invoice sent successfully");
        } else {
          const errorData = await response.json();
          setSnackbarOpen(true);
          setSnackbarMessage(`Failed to send invoice: ${errorData.message}`);
        }
      } catch (error) {
        console.error("Error:", error);
        setSnackbarOpen(true);
        setSnackbarMessage("Error sending invoice. Please try again.");
      }
    };
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <InvoiceLayout>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                mt: 4,
                border: "1px solid #d1d5db",
                "&:hover": {
                  border: "1px solid #9ca3af",
                },
              }}
            >
              <Typography variant="h6">{businessInfo.name}</Typography>
              <Typography variant="body2">
                Gst No: {businessInfo.gstNo}
              </Typography>
              <Typography variant="body2">
                Address: {businessInfo.address}
              </Typography>
              <Typography variant="body2">
                Email: {businessInfo.email}
              </Typography>
              <Typography variant="body2">
                Phone: {businessInfo.phoneNo}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <img
                src="./failogo.jpg"
                alt="F-AI Logo"
                style={{ maxWidth: "100%", maxHeight: "100px" }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2">
                Invoice Number: {invoiceId}
              </Typography>
              <DatePicker
                selected={currentDate}
                onChange={(date) => setCurrentDate(date)}
                customInput={
                  <TextField
                    label="Current Date"
                    variant="outlined"
                    size="small"
                  />
                }
              />
              <DatePicker
                selected={dueDate}
                onChange={(date) => setDueDate(date)}
                customInput={
                  <TextField label="Due Date" variant="outlined" size="small" />
                }
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Bill To
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              <TextField
                label="Name"
                name="name"
                value={billTo.name}
                onChange={handleBillToChange}
                size="small"
              />
              <TextField
                label="Email"
                name="email"
                value={billTo.email}
                onChange={handleBillToChange}
                size="small"
              />
              <TextField
                label="Phone"
                name="phoneNo"
                value={billTo.phoneNo}
                onChange={handleBillToChange}
                size="small"
              />
              <TextField
                label="GST No"
                name="gstNo"
                value={billTo.gstNo}
                onChange={handleGstBillToChange}
                size="small"
                error={!!gstError}
                helperText={gstError}
              />
              <TextField
                label="Address"
                name="address"
                value={billTo.address}
                onChange={handleBillToChange}
                size="small"
                sx={{ width: "343px" }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Items
            </Typography>
            {items.map((item) => (
              <Box
                key={item.id}
                sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center" }}
              >
                <Autocomplete
                  options={products || []}
                  value={item.description}
                  onChange={(event, newValue) => {
                    handleItemChange(
                      item.id,
                      "description",
                      typeof newValue === "string"
                        ? newValue
                        : newValue?.description || ""
                    );
                  }}
                  freeSolo
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    return option?.label || option?.description || "";
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Description"
                      size="small"
                      value={item.description}
                      onChange={(e) =>
                        handleItemChange(item.id, "description", e.target.value)
                      }
                      id={`description-${item.id}`}
                      sx={{ flexGrow: 1, width: "470px" }}
                    />
                  )}
                />
                <TextField
                  label="Qty"
                  type="number"
                  value={item.qty}
                  onChange={(e) =>
                    handleItemChange(item.id, "qty", e.target.value)
                  }
                  size="small"
                  sx={{ width: "600px" }}
                />
                <TextField
                  select
                  label="Unit"
                  value={item.unit}
                  onChange={(e) =>
                    handleItemChange(item.id, "unit", e.target.value)
                  }
                  size="small"
                  sx={{ width: "600px" }}
                >
                  {units.map((unit) => (
                    <MenuItem key={unit} value={unit}>
                      {unit}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Rate"
                  type="number"
                  value={item.rate}
                  onChange={(e) =>
                    handleItemChange(item.id, "rate", e.target.value)
                  }
                  size="small"
                  sx={{ width: "600px" }}
                />
                <TextField
                  label="gst"
                  type="number"
                  value={item.gst}
                  onChange={(e) =>
                    handleItemChange(item.id, "gst", e.target.value)
                  }
                  size="small"
                  sx={{ width: "600px" }}
                />
                <TextField
                  label="Discount"
                  type="number"
                  value={item.Discount}
                  onChange={(e) =>
                    handleItemChange(item.id, "Discount", e.target.value)
                  }
                  size="small"
                  sx={{ width: "600px" }}
                />

                <IconButton
                  onClick={() => deleteItem(item.id)}
                  color="error"
                  size="small"
                >
                  <MdDelete />
                </IconButton>
              </Box>
            ))}
            <Button
              startIcon={<MdAdd />}
              onClick={addItem}
              variant="outlined"
              size="small"
              sx={{ mb: 1 }}
            >
              Add Item
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                alignItems: "flex-end",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <TextField
                    label="Global Discount (%)"
                    type="number"
                    value={globalDiscountPercent}
                    onChange={(e) => {
                      const newGlobalDiscountPercent = Number(e.target.value);
                      setGlobalDiscountPercent(newGlobalDiscountPercent);
                      updateSubtotalAndTotal(items);
                    }}
                    size="small"
                    sx={{ width: "120px" }}
                  />
                  <Typography>%</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography>Discount Amount:</Typography>
                  <FaRupeeSign size={14} />
                  <Typography>{globalDiscountAmount.toFixed(2)}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h6">Total:</Typography>
                <FaRupeeSign size={18} />
                <Typography variant="h6">{total.toFixed(2)}</Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 1 }}
            >
              <Typography variant="subtitle1">Leave a Comment</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Avatar sx={{ width: 32, height: 32 }}>U</Avatar>
                <TextField
                  variant="outlined"
                  placeholder="Add a comment to the invoice..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  multiline
                  rows={2}
                  fullWidth
                  size="small"
                />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <Button
                variant="contained"
                onClick={generateEInvoice}
                startIcon={<MdAdd />}
              >
                Generate E-Invoice
              </Button>
              <Button
                onClick={sendInvoiceToCustomer}
                variant="contained"
                startIcon={<MdSend />}
              >
                Send to Customer
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </InvoiceLayout>
  );
};

export default InvoiceManagement;
